import { z } from "zod";

const formEditPartnerUMSchema = z.object({
  vlogaID: z
    .number()
    .nullable()
    .refine((val) => val !== null, {
      message: "Izberite vlogo partnerja",
    }),

  osebaSelected: z
    .object({
      value: z.number(),
      label: z.string(),
    })
    .nullable()
    .refine((data) => data !== null, {
      message: "Izberite kontaktno osebo",
    }),
});

export default formEditPartnerUMSchema;
